<template>
  <div class="browser-install" ref="wrapper">
    <!-- 主按钮 -->
    <div
	        class="main-btn"
	        :class="{ installed }"
	        data-track-text="安装浏览器插件"
	        aria-label="安装浏览器插件"
	        @click="handleMainClick"
    >
      <img :src="recommend.icon" class="icon" />
      <span class="text">
        {{ installed ? '已安装' : '安装到浏览器' }}
      </span>
      <span
          v-if="!installed"
          class="arrow"
          :class="{ open: visible }"
      >▼</span>
    </div>

    <!-- 下拉菜单 -->
    <transition name="fade-slide">
      <div v-if="visible && !installed" class="dropdown">
        <div
            v-for="item in browsers"
            :key="item.key"
	            class="item"
	            :class="{ active: item.key === recommend.key }"
	            :data-track-text="`选择${item.name}浏览器插件`"
	            :aria-label="`选择${item.name}浏览器插件`"
	            @click="onSelect(item)"
        >
          <img :src="item.icon" class="icon" />
          <span>{{ item.name }}</span>
          <span v-if="item.key === recommend.key" class="tag">推荐</span>
        </div>
      </div>
    </transition>

    <!-- 安装引导 -->
    <div v-if="showCrxGuide" class="mask">
      <div class="guide">
        <h3>插件安装指引</h3>
        <!-- Firefox 安装指引 -->
        <ol v-if="recommend.key === 'firefox'">
          <li>在新标签页打开 <b>about:addons</b></li>
          <li>点击右上角 <b>设置图标</b></li>
          <li>选择 <b>从文件安装附加组件</b></li>
          <li>选择下载的 <b>.xpi 文件</b> 完成安装</li>
        </ol>
        <!-- Chrome 安装指引 -->
        <ol v-else-if="recommend.key === 'chrome'">
          <li>在新标签页打开 <b>chrome://extensions</b></li>
          <li>打开右上角 <b>开发者模式</b></li>
          <li>将下载的 <b>.crx 文件</b> 拖入页面完成安装</li>
        </ol>
        <!-- Edge 安装指引 -->
        <ol v-else-if="recommend.key === 'edge'">
          <li>在新标签页打开 <b>edge://extensions</b></li>
          <li>打开左下角 <b>开发人员模式</b></li>
          <li>将下载的 <b>.crx 文件</b> 拖入页面完成安装</li>
        </ol>
        <!-- 360 安装指引 -->
        <ol v-else-if="recommend.key === '360'">
          <li>点击浏览器右上角 <b>三横线菜单</b></li>
          <li>选择 <b>工具</b> → <b>管理扩展</b></li>
          <li>打开右上角 <b>开发者模式</b></li>
          <li>将下载的 <b>.crx 文件</b> 拖入页面完成安装</li>
        </ol>
        <!-- 默认安装指引 -->
        <ol v-else>
          <li>在新标签页打开浏览器扩展管理页面</li>
          <li>打开 <b>开发者模式</b></li>
          <li>将下载的 <b>.crx 文件</b> 拖入页面完成安装</li>
        </ol>
        <div class="btns">
	          <el-button type="text" data-track-text="下载浏览器插件" aria-label="下载浏览器插件" @click="downloadCrxUrl">点击下载</el-button>
	          <el-button type="text" data-track-text="复制浏览器插件下载地址" aria-label="复制浏览器插件下载地址" @click="copyCrxUrl">复制下载地址</el-button>
          <el-button type="text" class="close" data-track-text="关闭浏览器插件安装提示" aria-label="关闭浏览器插件安装提示" @click="showCrxGuide=false">知道了</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserInstall',
  data() {
    return {
      visible: false,
      installed: false,
      showCrxGuide: false,
      crxUrl: '', // 动态设置,根据浏览器类型
      recommend: {},
      browsers: [
        {
          key: 'chrome',
          name: 'Chrome 扩展',
          version: 'v1.1.0',
          date: '2025-12-18',
          icon: require('@/assets/chrome.png'),
          url: 'https://chromewebstore.google.com/detail/cdpkngbnfjeelhmgfggihlbgmkaiidbo?utm_source=item-share-cb',
          crxUrl: 'https://wesitrans.com/wesitrans/template/plugin/google/cdpkngbnfjeelhmgfggihlbgmkaiidbo.crx' // Chrome CRX 下载地址
        },
        {
          key: 'edge',
          name: 'Edge 扩展',
          version: 'v1.1.0',
          date: '2025-12-18',
          icon: require('@/assets/edge.png'),
          url: 'https://microsoftedge.microsoft.com/addons/detail/%E5%BE%AE%E6%80%9D%E7%BF%BB%E8%AF%91/daalcfjjbfcgnpidbehollklelokkphd',
          crxUrl: 'https://wesitrans.com/wesitrans/template/plugin/edge/cdpkngbnfjeelhmgfggihlbgmkaiidbo.crx' // Edge CRX 下载地址
        }, {
          key: '360',
          name: '360 扩展',
          version: 'v1.0.8',
          date: '2025-12-15',
          icon: require('@/assets/360.png'),
          url: 'https://ext.se.360.cn/#/extension-detail?id=mhlkeimenpnfblcembibldphkdpapdcg',
          crxUrl: 'https://wesitrans.com/wesitrans/template/plugin/360/translate-plugin-360.crx' // 360 CRX 下载地址
        },
        {
          key: 'firefox',
          name: 'Firefox 扩展',
          version: 'v1.0.2',
          date: '2025-12-16',
          icon: require('@/assets/firefox.png'),
          url: 'https://addons.mozilla.org/zh-CN/firefox/addon/%E5%BE%AE%E6%80%9D%E7%BF%BB%E8%AF%91/',
          crxUrl: 'https://wesitrans.com/wesitrans/template/plugin/firefox/2964742-1.0.2.xpi' // Firefox XPI 下载地址
        },
        {
          key: 'package',
          name: '', // 动态设置,根据浏览器类型
          version: 'v1.1.0',
          date: '2025-12-18',
          icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABcCAMAAACvFeCmAAAAAXNSR0IArs4c6QAAASBQTFRFAAAAAP//VcaOXdGia8r/asr/bcv/bs3/bdD/a8z/WcydWc2eWs+bXMycW8ubWcubbMr/bcr/a8v/wYak6md57YeV8Z2n++XpW86cWs2bWsycWs2cvYR47mJo72518bi58/Hwa8v/bMv/WsycW82bbMv/bMv/W8ycrtC5WsybvNR9rtG6utN9sNG5bMz/u9J8bMv/WsybbMv/bMv/Wc2b5H1/6X5r/9dmWsybbMv//9dmWsybWsybbMv/xn11zH2Y/1Vi/1tn/1xp/11p/2Nv/2Zy/2dy/2dz/2x3/214/3+I/4Fj/5yj/52k/5+m/6Cn/6Go/6eu/6iu/6ux/6uy/6yy/7K4/7O4/7O5/7S5/7S6/7W6/7a8/7e9/9dm////6pzy4wAAADx0Uk5TAAEJCyswMTM2NzxCSlBUWWFlcHh8fX1/gYWQkJeam6Gnsrm+xc/U5+rr6+3t7u/w8fL09fj5+fn6+vr7SGHQtgAAAXNJREFUaN7tmvdPwkAUgJ97T9yCe+8F4jigdVDFScWN/v//hfoOm7Smd2jybKDv+7FJ70tz72svBACApu5eBZE+NwODSL9zIaK6u6el5tMAjbNCSTrj5uIdOXcupNX3zzUD1G8IWonYaoBJQS0RU7BGL9mGvbIlxiVy+4qclS8Rv5Acy0coep6MJQFKjopIQe7/CY3kzyPMEjKJcYXknxGLOwmLxHxC7Gsky51w8dxJBUoWVjXEneLljhe8xcd1KyzD7puGnG6Ec7oV9llCJTFukPw9YtFI/EaYJcFJzAfElvuf5U5CU7zPN547qfbi5Y7bcv+5eC6eO6lEycq6hoRT/Aty5y0+oVthCQ51pHQjnNKtkGQJleT7VC/PeBaNxG+EWRKcxHxEfvxyx51Ue/Glb7x843Px4Snedao/5U64eK1kh36EN2GGXjINbQfUkmQrQMcirWS+/evfMXVdw6MKorESYxPIeMxDVHHzyFBnLfwPH1Bfp89sj42NAAAAAElFTkSuQmCC',
          crxUrl: '', // 默认地址,将根据浏览器动态设置
          fileExt: '' // 文件扩展名,动态设置
        }
      ]
    };
  },
  mounted() {
    this.detectBrowser();
    this.detectInstalled();
    document.addEventListener('click', this.onOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onOutsideClick);
  },
  computed: {
    // 获取当前推荐浏览器的版本信息
    currentVersion() {
      if (this.recommend && this.recommend.version) {
        return `最新版本:${this.recommend.version} ${this.recommend.date}`;
      }
      return '最新版本:v1.1.0 2025-12-18';
    }
  },
  methods: {
    handleMainClick() {
      if (this.installed) return;
      this.visible = !this.visible;
    },

    onSelect(item) {
      this.visible = false;

      if (item.key === 'package') {
        // 设置对应浏览器的安装包下载地址
        this.crxUrl = item.crxUrl || this.recommend.crxUrl || '';
        this.showCrxGuide = true;
        return;
      }

      window.open(item.url, '_blank');
      localStorage.setItem('ext_install_click', '1');
    },

    /** 检测是否为360浏览器 */
    is360Browser() {
      const ua = navigator.userAgent.toLowerCase();
      // 方法1: 直接检测UA中是否包含360标识
      if (ua.includes('360') || ua.includes('qihu')) {
        return true;
      }
      // 方法2: 使用现代userAgentData API检测
      if (navigator.userAgentData && navigator.userAgentData.brands) {
        const brands = navigator.userAgentData.brands.map(b => b.brand.toLowerCase());
        if (brands.some(b => b.includes('360') || b.includes('qihu'))) {
          return true;
        }
      }
      // 方法3: 检测360浏览器窗口特征 (360浏览器侧边栏导致宽度差异较大)
      if (ua.includes('chrome') && !ua.includes('edg') && !ua.includes('opr')) {
        // 360浏览器通常有较宽的边框
        const widthDiff = window.outerWidth - window.innerWidth;
        const heightDiff = window.outerHeight - window.innerHeight;
        if (widthDiff > 180 || heightDiff > 150) {
          // 配合中文语言环境判断
          const lang = navigator.language || '';
          if (lang.startsWith('zh')) {
            return true;
          }
        }
      }
      return false;
    },

    /** 浏览器识别 */
    detectBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      let key = 'package';

      // 360浏览器检测(需要在Chrome检测之前,因为360也包含chrome标识)
      if (this.is360Browser()) {
        key = '360';
      }
      // Edge检测(需要在Chrome之前,因为Edge也包含chrome标识)
      else if (ua.includes('edg')) {
        key = 'edge';
      }
      // Chrome检测
      else if (ua.includes('chrome')) {
        key = 'chrome';
      }
      // Firefox检测
      else if (ua.includes('firefox')) {
        key = 'firefox';
      }

      this.recommend =
          this.browsers.find(b => b.key === key) || this.browsers[0];

      // 动态设置当前浏览器的 CRX 下载地址
      this.crxUrl = this.recommend.crxUrl || '';

      // 动态设置"安装包"选项的名称和文件扩展名
      const packageItem = this.browsers.find(b => b.key === 'package');
      if (packageItem) {
        if (key === 'firefox') {
          packageItem.name = 'XPI 安装包';
          packageItem.fileExt = '.xpi';
          packageItem.crxUrl = this.recommend.crxUrl;
        } else {
          packageItem.name = 'CRX 安装包';
          packageItem.fileExt = '.crx';
          packageItem.crxUrl = this.recommend.crxUrl;
        }
      }
    },

    /** 安装状态检测（官方可行方案） */
    detectInstalled() {
      // Chrome / Edge：runtime ping
      try {
        if (window.chrome?.runtime?.sendMessage) {
          chrome.runtime.sendMessage(
              'YOUR_EXTENSION_ID',
              { action: 'PING' },
              () => {
                this.installed = true;
                localStorage.setItem('ext_installed', '1');
              }
          );
        }
      } catch (e) {}

      // 兜底：本地标记
      if (localStorage.getItem('ext_installed') === '1') {
        this.installed = true;
      }
    },
    downloadCrxUrl(){
      window.open(this.crxUrl, '_blank');
    },
    copyCrxUrl() {
      navigator.clipboard.writeText(this.crxUrl);
      this.$message.info("下载地址已复制");
    },

    onOutsideClick(e) {
      if (!this.$refs.wrapper.contains(e.target)) {
        this.visible = false;
      }
    }
  }
};
</script>

<style scoped>
.browser-install {
  position: relative;
  display: inline-block;
  font-family: PingFang SC, Arial;
}

/* 主按钮 */
.main-btn {
  display: flex;
  align-items: center;
  background: var(--primary-alpha-08);
  color: #1f2937;
  padding: 12px 16px;
  border-radius: 10px;
  cursor: pointer;
  width: 208px;
  transition: background-color 0.16s ease;
}
.main-btn:hover {
  background: var(--primary-alpha-14);
}
.main-btn.installed {
  background: var(--primary-light);
  color: #6b7280;
  cursor: default;
}

.icon {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  background-color: white;
  border-radius: 5px;
  padding: 3px;
}

.arrow {
  transition: transform .2s;
  margin-left: auto;
  padding-left: 10px;
  border-left: 1px solid hsla(0, 0%, 100%, .2);
}
.arrow.open {
  transform: rotate(180deg);
  border-right: 1px solid hsla(0, 0%, 100%, .2);
  padding-right: 10px;
  padding-left: 0px !important;
  border-left: 0px solid hsla(0, 0%, 100%, .2) !important;
}

/* 下拉 */
.dropdown {
  position: absolute;
  top: 56px;
  left: 0;
  width: 240px;
  background: var(--primary);
  border-radius: 12px;
  padding: 8px 0;
  box-shadow: 0 10px 28px rgba(0,0,0,.18);
  z-index: 10;
}

.item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  color: #ffffff;
  cursor: pointer;
}
.item:hover {
  background: rgba(255,255,255,.18);
}
.item.active {
  background: rgba(255,255,255,.28);
}

.tag {
  margin-left: auto;
  font-size: 12px;
  background: #fff;
  color: #1f2937;
  padding: 2px 6px;
  border-radius: 6px;
}

/* 动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .18s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* CRX 引导 */
.mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.guide {
  width: 360px;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
}
.btns {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 768px) {
  .browser-install {
    display: block;
    width: 100%;
    max-width: 300px;
    min-width: 0;
    margin: 0 auto;
  }

  .main-btn {
    width: 100%;
    min-width: 0;
    min-height: 48px;
    box-sizing: border-box;
  }

  .main-btn .icon,
  .main-btn .arrow {
    flex-shrink: 0;
  }

  .main-btn .text {
    flex: 1 1 auto;
    min-width: 0;
    text-align: left;
  }

  .dropdown {
    top: 56px;
    width: 100%;
    max-width: 100%;
    max-height: calc(100vh - 160px);
    max-height: calc(100dvh - 160px);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .mask {
    padding: 16px;
    box-sizing: border-box;
  }

  .guide {
    width: 100%;
    max-width: 360px;
    max-height: calc(100vh - 32px);
    max-height: calc(100dvh - 32px);
    padding: 18px 16px;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .guide h3 {
    margin-top: 0;
  }

  .guide ol {
    padding-left: 22px;
  }

  .btns {
    flex-wrap: wrap;
    gap: 8px;
  }

  .btns >>> .el-button + .el-button {
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .btns {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .btns >>> .el-button {
    width: 100%;
    min-width: 0;
    min-height: 40px;
    margin: 0;
    white-space: normal;
  }

  .btns >>> .el-button.close {
    grid-column: 1 / -1;
  }
}
</style>
